import styled from 'styled-components';

export const AppWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.background};
  transition: background-color 0.3s ease;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 24px 32px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 20px 24px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0;
    align-items: stretch;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  /* max-width: 1600px; */
  height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    gap: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 0;
  }
`;
